<template>
  <div class="locale-changer">
    <img
      src="@/assets/images/Flag_of_Germany.svg"
      height="20"
      width="30"
      alt=""
      style="cursor: pointer; padding: 2px"
      @click="changeLocale('de')"
    />
    <img
      src="@/assets/images/Flag_of_the_United_Kingdom_(3-5).svg"
      height="20"
      width="30"
      alt=""
      style="cursor: pointer; padding: 2px"
      @click="changeLocale('en')"
    />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    function changeLocale(loc) {
      locale.value = loc;
    }

    return { t, locale, changeLocale };
  },
};
</script>

<style lang="scss" scoped>
.locale-changer {
  float: left;
  padding-left: 5px;
}
</style>
